module.exports = __webpack_public_path__ + "img/big.81302230.jpg";